import { combineReducers } from "@reduxjs/toolkit";
import theme from "./theme";

const rootReducer = combineReducers({
  theme,
});
export default rootReducer;
